import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import data from '../../data/cidr2.json';

const ColumnTypePieChart = () => {
    //2_column_type_distribution

    if (!Array.isArray(data)) {
        return <div>Loading chart...</div>;
    }

    const total = data.reduce((sum, item) => sum + item.Count, 0);

    const option = {
        title: {
            text: '', //`Total\n${total}`,
            left: 'center',
            top: 'middle', // keeps it centered in the donut hole
            textStyle: {
                fontSize: 16,
                fontWeight: 'bold',
                align: 'center',
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
        },
        tooltip: {
            trigger: 'item',
            formatter: '{b}: {c} ({d}%)',
        },
        legend: {
            orient: 'horizontal',
            top: 'top',
            left: 'center',
            textStyle: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
        },
        series: [
            {
                name: 'Column Types',
                type: 'pie',
                radius: ['40%', '70%'], // Donut style
                center: ['50%', '65%'],
                data: data.map(item => ({
                    name: item.Column_Type,
                    value: item.Count,
                })),
                label: {
                    show: true,
                    position: 'outside',
                    formatter: '{b}: {d}%', // Show label and percentage
                    color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
                },
                labelLine: {
                    show: true,
                },
                itemStyle: {
                    borderRadius: 6,
                    borderColor: '#fff',
                    borderWidth: 2,
                },
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)',
                    },
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4  shadow">
            <ReactECharts option={option} style={{ height: 500, width: '100%' }} />
        </div>
    );
};

export default ColumnTypePieChart;
